import { IconButton, Tooltip } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

type Props = {
  layerNumber: number;
  disabled: boolean;
  onAddMaterial: (layerNumber: number) => void;
};

export const AddMaterialButton = ({
  layerNumber,
  disabled,
  onAddMaterial,
}: Props) => (
  <Tooltip title="Add material to this layer">
    <span>
      <IconButton
        onClick={() => onAddMaterial(layerNumber)}
        color="primary"
        disabled={disabled}
        size="small"
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </span>
  </Tooltip>
);
